export default {
    i18n: {
        "Access Denied.": "تم الرفض.",
        "Fingerprint": "بصمة",
        "Date Time": "وقت التاريخ",
        "name": "اسم",
        "tamperAlarm": "إنذار العبث",
        "bluetooth": "بلوتوث",
        "day": "يوم",
        "Device Information": "معلومات الجهاز",
        "handset": "سماعة الهاتف",
        "Http": " HTTP",
        "Device Name": "اسم الجهاز",
        "auto": "تلقائي",
        "Group": "المجموعة",
        "Volume": "مقدار",
        "Card": "بطاقة",
        "minutes": "دقائق",
        "timezone": "المنطقة الزمنية",
        "Are you sure you want to delete this device?": "هل أنت متأكد أنك تريد حذف هذا الجهاز؟",
        "Attendance Point Name": "اسم نقطة الحضور",
        "Mac": "MAC",
        "confirmToDeleteIt?": "تأكيد لحذفه؟",
        "captureLogs": "سجلات التقاط",
        "Doors": "أبواب",
        "All Doors": "جميع الأبواب",
        "Lock List": "قائمة القفل",
        "Link Device Relay": "رابط RELAY الجهاز",
        "Added Successfully!": "اضيف بنجاح!",
        "When the lock is linked with a relay, the lock will be unlocked when relay is triggered.": "عندما يتم ربط القفل بالريلاي ، سيتم إلغاء قفل القفل عند تشغيل الريلاي.",
        "Adding...": "جارٍ الإضافة...",
        "Please try again 24 hours later.": "يرجى المحاولة مرة أخرى بعد 24 ساعة.",
        "Action": "فعل",
        "unlock": "فتح",
        "Address": "عنوان",
        "Owner": "مالك",
        "Failed": "فشل",
        "Timeout": "نفذ الوقت",
        "Response": "النتيجة",
        "caller": "المتصل",
        "receiver": "المتلقي",
        "doorLogs": "سجلات الأبواب",
        "callHistory": "سجل المكالمات",
        "UID": "UID",
        "Call Type": "نوع الاتصال",
        "Code": "شفرة",
        "User": "مستخدم",
        "Device List": "قائمة الأجهزة",
        "Model": "نموذج",
        "Time": "وقت",
        "Company": "شركة",
        "Property Managers": "مديرو العقارات",
        "Current Version": "الإصدار الحالي",
        "indoorMonitor": "مراقب داخلي",
        "guardPhone": "هاتف الحرس",
        "close": "يغلق",
        "Success": "نجاح",
        "URL": "عنوان URL",
        "Please select a device.": "يرجى اختيار جهاز.",
        "Password is too weak.": "كلمة المرور ضعيفة جدًا.",
        "Company is required.": "يرجى إدخال اسم الشركة",
        "Your account is not activated, please contact your service provider.": "لم يتم تفعيل حسابك ، يرجى الاتصال بمزود الخدمة الخاص بك.",
        "Language": "لغة",
        "Face": "وجه",
        "Please set at least one access type.": "يرجى تحديد نوع وصول واحد على الأقل.",
        "Please contact your service provider to activate this advanced feature.": "يرجى التواصل مع مقدم الخدمة لتفعيل هذه الميزة المتقدمة.",
        "Community name": "اسم المجتمع",
        "Please enable PM App first.": "يرجى تمكين تطبيق PM أولاً.",
        "Username": "اسم المستخدم",
        "Change Log": "سجل التغيير",
        "Assign": "تخصيص",
        "Floor": "أرضية",
        "Link Device": "ربط الجهاز",
        "Accessible Floors": "الطوابق المتاحة",
        "Upgrade": "يرقي",
        "Function": "وظيفة",
        "callDuration": "مدة المكالمة",
        "No": "لا",
        "Verification Code": "Verification Code",
        "Expiration Time": "تاريخ انتهاء الصلاحية",
        "PIN": "PIN",
        "MAC": "MAC",
        "Building": "مبنى",
        "APT": "APT",
        "ID": "المعرف",
        "Name": "الاسم",
        "activities": "أنشطة",
        "Obtain": "يحصل على",
        "call": "اتصال",
        "Group Call": "مكالمة جماعية",
        "Delete": "يمسح",
        "Yes": "نعم",
        "Door Release PIN": "الرمز السري لفنح الباب",
        "Email": "بريد إلكتروني",
        "Mobile Number doesn\'t exist.": "رقم الهاتف المحمول غير موجود.",
        "Tips": "نصائح",
        "Password": "كلمة المرور",
        "The end time cannot be earlier than the start time.": "لا يمكن أن يكون وقت الانتهاء أقدم من وقت البدء.",
        "Back": "الى الخلف",
        "File format error.": "خطأ تنسيق الملف.",
        "motionDetection": "كشف الحركة",
        "You are trying too often, please try again in 5 minutes": "أنت تحاول كثيرًا ، يرجى المحاولة مرة أخرى في 5 دقائق",
        "User name too long.": "اسم المستخدم طويل جداً (حتى 63 حرفاً كحد أقصى).",
        "This MAC address is redirected on RPS.": "يتم إعادة توجيه عنوان MAC هذا في RPS.",
        "No Answer": "لا اجابة",
        "failedToUnlock": "فشل فتح",
        "visitor": "زائر",
        "yesterday": "أمس",
        "Too large data! Please first export the data before %s first,thanks.": "بيانات كبيرة جدا!",
        "Please check if there is any unpaid orders, if not, please contact your service provider.": "يرجى التحقق مما إذا كان هناك أي طلبات غير مدفوعة ، إذا لم يكن الأمر كذلك ، يرجى الاتصال بمزود الخدمة الخاص بك",
        "lock": "قفل",
        "open": "يفتح",
        "The PersonalAccount is not active.": "PersonalAccount غير نشط.",
        "You cannot link an account that already link other accounts.": "لا يمكنك ربط حساب يربط الحسابات الأخرى بالفعل.",
        "You cannot link multiple property manager accounts under the same installer account.": "لا يمكنك ربط حسابات مدير الخصائص المتعددة ضمن حساب المثبت نفسه.",
        "You cannot link to the currently logged in account.": "لا يمكنك ربط الحساب المسجل حاليًا.",
        "nfc": "NFC",
        "Delete Device": "حذف الجهاز",
        "date": "تاريخ",
        "Device deleted successfully": "تم حذف الجهاز بنجاح",
        "Failed to delete device": "فشل في حذف الجهاز",
        "Are you sure you want to cancel?": "هل أنت متأكد أنك تريد الإلغاء؟",
        "Unlimited": "غير محدود",
        "Battery Level": "مستوى البطارية",
        "Password Incorrect.": "كلمة المرور غير صحيحة.",
        "deliverySystemVerification": "التحقق من نظام التوصيل",
        "None": "لا شيء",
        "Upgrading...": "جارٍ الترقية...",
        "amenityReservation": "حجز المرافق العامة",
        "idAccess": "الوصول إلى الهوية",
        "RF Card": "بطاقة RF",
        "exitButton": "زر الخروج",
        "Please select at least one item.": "يرجى اختيار عنصر واحد على الأقل",
        "The ID can contain only digits and letters, up to 32 characters.": "يمكن أن يتكون المعرف من أرقام وحروف فقط، حتى 32 حرفًا.",
        "The PIN is not available.": "رمز PIN غير متوفر",
        "Change WiFi": "تغيير الواي فاي",
        "Phone number": "رقم الهاتف",
        "Invalid {0}.": "{0} غير صالح",
        "{0} already exists.": "{0} موجود مسبقًا",
        "Operation failed!": "فشل العملية",
        "Failed to get data.": "فشل الحصول على البيانات",
        "You do not have the necessary permissions to perform this operation.": "ليس لديك صلاحيات لهذه العملية",
        "You can only import one template at a time in the current site.": "يمكنك استيراد قالب واحد فقط في الموقع الحالي",
        "Delivery name": "اسم تفويض التسليم",
        "MAC address not in the MAC library.": "عنوان MAC غير موجود في مكتبة MAC.",
        "Please delete devices under this building.": "يرجى حذف الأجهزة تحت هذا المبنى أولاً.",
        "The start time cannot be later than the end time.": "لا يمكن أن يكون وقت البدء بعد وقت الانتهاء.",
        "emergency action type": "نوع إجراء الطوارئ",
        "Only 1000 data items can be imported at a time.": "يمكن استيراد 1000 عنصر بيانات كحد أقصى في كل مرة.",
        "The password is too short.": "كلمة المرور قصيرة جدًا",
        "The data has been updated. Please refresh the page and try again.": "تم تحديث البيانات، يرجى تحديث الصفحة والمحاولة مجددًا.",
        "AutoP length must be less 2048 bytes.": "يجب أن يكون طول أمر AutoP أقل من 2048 بايت",
        "File Check Failed": "فشل فحص الملف",
        "administratorAccountLoginHasExpired.PleaseContactYourServiceProvider.": "انتهت صلاحية تسجيل دخول حساب المسؤول. يرجى الاتصال بمزود الخدمة.",
        "iqPinVerificationFailed": "فشل التحقق من رمز PIN الخاص بـ IQ.",
        "accountBlacklisted": "تم إدراج الحساب في القائمة السوداء.",
        "outsideAuthorizedTime": "خارج الوقت المصرح به.",
        "network group": "مجموعة الشبكة",
        "Company name": "اسم الشركة",
        "Group name": "اسم المجموعة",
        "relay": "باب",
        "motionTime": "وقت اكتشاف الحركة",
        "motionType": "نوع اكتشاف الحركة",
        "postalCode": "الرمز البريدي",
        "floor format": "تنسيق الطابق",
        "mobilePhone": "رقم الجوال",
        "time format": "تنسيق الوقت",
        "security relay": "مرحّل الأمان",
        "Param": "معامل",
        "Offline Code": "كلمة مرور دون اتصال",
        "Add akubela Smart Locks": "إضافة أقفال akubela الذكية",
        "Module Version": "إصدار الوحدة",
        "Lock Body Version": "إصدار جسم القفل",
        "Available Version": "الإصدار المتاح",
        "Please wake up the lock screen and then upgrade.": "يرجى تنشيط شاشة القفل ثم التحديث.",
        "This process will take some time, please be patient.": "هذه العملية ستستغرق بعض الوقت، يرجى التحلي بالصبر.",
        "Please confirm that the WiFi network is functioning properly.": "يرجى التأكد من أن شبكة WiFi تعمل بشكل سليم.",
        "Please wake up the lock screen.": "يرجى تنشيط شاشة القفل.",
        "This lock has already been added to another apartment.": "هذا القفل قد تم إضافته بالفعل إلى شقة أخرى.",
        "This lock has already been added to the apartment.": "تم إضافة هذا القفل إلى الشقة.",
        "Pin Code": "رمز التعريف الشخصي",
        "Too many failed attempts, please try again in a few minutes.": "محاولات خاطئة كثيرة، يرجى المحاولة بعد عدة دقائق.",
        "Login Account": "حساب الدخول",
        "Same account cannot login in different ins.": "لا يمكن تسجيل الدخول بنفس الحساب في أكثر من شركة تركيب مختلفة.",
        "Lock Name": "اسم القفل",
        "Smart Locks": "الأقفال الذكية",
        "Add Smart Lock": "إضافة قفل ذكي",
        "The selected duration cannot be more than one year.": "المدة المختارة لا يمكن أن تتجاوز سنة واحدة.",
        "The end time of the break time cannot be later than the end work time.": "وقت نهاية الاستراحة لا يمكن أن يكون بعد وقت انتهاء العمل.",
        "The start time of the break time cannot be earlier than the start work time.": "وقت بدء الاستراحة لا يمكن أن يكون قبل وقت بدء العمل.",
        "The end time of the valid check time cannot be earlier than the end work time.": "وقت نهاية فترة التحقق الصالحة لا يمكن أن يكون قبل وقت الانتهاء من العمل.",
        "The start time of the valid check time cannot be later than the start work time.": "وقت بدء فترة التحقق الصالحة لا يمكن أن يكون بعد وقت بدء العمل.",
        "Deleting failed. The timetable is used by a shift.": "فشل الحذف. الجدول مستخدم في دوام.",
        "Deleting failed. The shift is in use.": "فشل الحذف. الدوام مستخدم بالفعل.",
        "Deleting failed. The leave type is in use.": "فشل الحذف. نوع الإجازة مستخدم بالفعل.",
        "Valid time conflicts with an existing schedule.": "فترة الزمن تتعارض مع جدول زمني موجود.",
        "The timing for multiple schedules must not coincide.": "مواقيت جداول متعددة يجب ألا تتداخل.",
        "Attendance Log": "سجل الحضور",
        "Added Failed!": "فشل في الإضافة!",
        "Setting WiFi": "إعداد الواي فاي",
        "License Plate": "رقم لوحة السيارة",
        "key": "كلمة المرور",
        "IQ Offline.": "وحدة IQ غير متصلة.",
        "{0}Unlock": "{0} إلغاء القفل",
        "automatically": "تلقائياً",
        "manually": "يدوياً",
        "Video Storage": "تخزين الفيديو",
        "Device(s) for Video Storage": "الأجهزة الخاصة بتخزين الفيديو",
        "The amount of exported data is too large. Please export it in batches.": "كمية البيانات المصدرة كبيرة جداً، يرجى تصديرها على دفعات.",
        "Auto-record video when door unlocks": "تسجيل الفيديو تلقائياً عند فتح الباب",
        "Auto-record video during calls": "تسجيل الفيديو تلقائياً أثناء المكالمات",
        "Manual video recording in monitoring": "تسجيل الفيديو يدوياً أثناء المراقبة",
        "Saved for 30days/60days/90days": "الحفظ لمدة 30/60/90 يوم",
        "To subscribe, please contact your provider for activation.": "للاشتراك، يرجى الاتصال بمزود الخدمة لتفعيل الخدمة.",
        "Saved for {0}days": "الحفظ لمدة {0} يوم",
        "Subscribed Plan": "الخطة المشترك بها",
        "Supported Devices: {0}": "الأجهزة المدعومة: {0}",
        "{0}Lock": "{0} إقفال الباب",
        "Video Saving": "حفظ الفيديو",
        "Download Completed!": "اكتمل التحميل!",
        "Fail to download.": "فشل التحميل.",
        "Deleting failed! The property manager has been bound to a RentManager Customer, you should delete it firstly.": "فشل الحذف! تم ربط مدير العقار بحساب عميل في RentManager، يجب عليك حذفه أولاً.",
        "No log to be exported.": "لا يوجد سجل للتصدير",
        "capture&Video": "لقطة شاشة & فيديو",
        "packageDetection": "الكشف عن الطرد",
        "Time format is invalid.": "تنسيق الوقت غير صالح.",
        "No permission to export logs of this type.": "لا صلاحية لتصدير سجلات من هذا النوع.",
        "Project type is invalid.": "نوع المشروع غير صالح.",
        "Salto Account Blocked.": "تم حظر حساب سالتو.",
        "Remote open not in access group.": "الفتح عن بعد غير متوفر ضمن مجموعة الصلاحيات.",
        "SIP Account required.": "حساب SIP مطلوب.",
        "The PIN must be {0} digits.": "يجب أن يكون رمز PIN مكونًا من {0} أرقام.",
        "gatewayConnectionUnavailable": "الاتصال بالبوابة غير متوفر.",
        "Invalid Username or Password": "اسم المستخدم أو كلمة المرور غير صحيحة.",
        "Account already linked to another user.": "الحساب مربوط بالفعل بمستخدم آخر.",
        "The account has been added by another user.": "تمت إضافة الحساب بواسطة مستخدم آخر.",
        "Failed to add. This user already has 5 license plates.": "فشل في الإضافة، هذا المستخدم لديه بالفعل 5 لوحات سيارات.",
        "Please at least select a door.": "يرجى اختيار باب واحد على الأقل.",
        "UHF Card": "بطاقة UHF",
        "personnel": "الأشخاص",
        "Parking Lot Name": "اسم موقف السيارات",
        "Controlled Relay": "مرحّل مُراقب",
        "No Permission": "لا توجد صلاحية",
        "Please ensure that all doors in the project are activated at the same time.": "يرجى التأكد من تفعيل جميع الأبواب في المشروع في نفس الوقت.",
        "gatewayBusy": "البوابة مشغولة",
        "Please set the perimeter door group first.": "يرجى تعيين مجموعة أبواب المحيط أولاً.",
        "Please ensure that all doors in the project are renewed at the same time.": "يرجى التأكد من تجديد جميع الأبواب في المشروع في نفس الوقت.",
        "When lockdown is on, the controlled relay cannot be modified.": "عند تفعيل وضع الإغلاق، لا يمكن تعديل المرحّل.",
        "DetectionLogs": "سجلات الكشف",
        "packageIn": "إدخال الطرد",
        "packageOut": "إخراج الطرد",
        "View Progress": "عرض التقدم",
        "Check if the WiFi is operating on the 2.4GHz band.": "تحقق مما إذا كانت شبكة الواي فاي تعمل على نطاق 2.4 جيجاهرتز.",
        "Verify that the WiFi password is correct.": "تحقق من صحة كلمة مرور الواي فاي.",
        "Ensure that you are connected to the correct device hotspot during the hotspot configuration.": "تأكد من أنك متصل بنقطة الاتصال الصحيحة للجهاز أثناء إعداد نقطة الاتصال.",
        "Offline Code Unlock": "فتح القفل برمز غير متصل",
        "Salto Token Expired.": "انتهت صلاحية رمز Salto.",
        "Lock Offline": "القفل غير متصل",
        "identity information! Please login again": "معلومات الهوية! يرجى تسجيل الدخول مرة أخرى",
        "Email is required.": "البريد الإلكتروني مطلوب.",
        "Mobile number is required.": "رقم الجوال مطلوب.",
        "You can\'t make payments for offices in different time zones.": "لا يمكنك إجراء المدفوعات للمكاتب الموجودة في مناطق زمنية مختلفة.",
        "The current scheduling staff exceeds 200 people.": "عدد الموظفين في الجدولة تجاوز 200 شخص.",
        "param": "معامل",
        "Invalid UserName or Password": "اسم المستخدم أو كلمة المرور غير صالحة",
        "Your Salto KS account does not have permission to modify the lock\'s name.": "حسابك في Salto KS ليس لديه إذن لتعديل اسم القفل.",
        "Owner is required.": "المطلوب إدخال مالك.",
        "Office is required.": "المطلوب إدخال مكتب.",
        "PIN or RF Card is required.": "مطلوب رمز PIN أو بطاقة RF.",
        "RF card": "بطاقة دخول",
        "Personnel is required.": "الأشخاص مطلوبون.",
        "email address": "عنوان البريد الإلكتروني",
        "mobile number": "رقم الجوال",
        "The length must be less than 32 characters.": "يجب أن يكون الطول أقل من 32 حرفاً.",
        "The length must be less than 256 characters.": "يجب أن يكون الطول أقل من 256 حرفاً.",
        "Access Group is required.": "مجموعة الصلاحية مطلوبة.",
        "Device is required.": "الجهاز مطلوب.",
        "Admin is required.": "المطلوب إدخال مدير.",
        "Mobile number": "رقم الجوال",
        "schedules": "الجداول الزمنية",
        "Timetable name": "اسم الجدول الزمني",
        "Shift name": "اسم الوردية",
        "Leave type": "نوع الإجازة",
        "recheck in time": "إعادة توقيت الدخول",
        "recheck out time": "إعادة توقيت الخروج",
        "The building name": "اسم المبنى",
        "Building is required.": "المبنى مطلوب.",
        "selection, The same reader cannot be set for both entry and exit": "الاختيار، لا يمكن تعيين نفس القارئ لكل من الدخول والخروج",
        "Door number": "رقم الباب",
        "door input cannot be selection duplicated.": "لا يمكن تكرار اختيار مدخل الباب.",
        "Group is required.": "المجموعة مطلوبة.",
        "Title can contain up to 32 characters.": "العنوان يمكن أن يحتوي على 32 حرفاً كحد أقصى.",
        "Content can contain up to 1024 characters.": "المحتوى يمكن أن يصل إلى 1024 حرف.",
        "Content can contain up to 64 characters.": "المحتوى يمكن أن يصل إلى 64 حرف.",
        "Report is required.": "التقرير مطلوب.",
        "ID is required.": "المعرف مطلوب.",
        "The office does not exist.": "المكتب غير موجود.",
        "Office name": "اسم المكتب",
        "The Temp Key does not exist.": "مفتاح مؤقت غير موجود.",
        "autolock time": "وقت الإغلاق التلقائي",
        "The User does not exist.": "المستخدم غير موجود.",
        "The Installer does not exist.": "مثبّت غير موجود.",
        "The Project does not exist.": "المشروع غير موجود.",
        "The Distributor does not exist.": "الموزع غير موجود.",
        "The Community Device does not exist.": "جهاز المجتمع غير موجود.",
        "The Property Manager does not exist.": "مدير العقار غير موجود.",
        "The Sub Distributor does not exist.": "الموزع الفرعي غير موجود.",
        "The Single Slave does not exist.": "حساب العائلة الفرعي لا يوجد.",
        "The Property Manager EndUser does not exist.": "مستخدم نهائي لمدير العقار غير موجود.",
        "The Family Member does not exist.": "عضو العائلة غير موجود.",
        "Set Failed!": "فشل الإعداد!",
        "You have reached the limit of 10 access code requests within a 30-minute period. Please try again later.": "لقد وصلت إلى الحد الأقصى لطلب رموز الدخول (10) خلال 30 دقيقة، يرجى المحاولة لاحقاً.",
        "This Email doesn\'t exist.": "البريد الإلكتروني غير موجود.",
        "detection type": "نوع الكشف",
        "Device UUID": "معرف الجهاز UUID",
        "smart lock device": "جهاز قفل ذكي",
        "You are trying too often, please try again in 5 minutes.": "المحاولة بشكل متكرر، جرب بعد 5 دقائق.",
        "You can only import one file at a time. Please wait for the current import to finish.": "يمكنك استيراد ملف واحد فقط في كل مرة. يرجى الانتظار حتى ينتهي الاستيراد الحالي.",
        "NVR Name": "اسم NVR",
        "NVR Address": "عنوان NVR",
        "Stay Alarm": "إنذار البقاء المطول",
        "Happended On": "حدث في",
        "Edit Milesight NVR": "تعديل Milesight NVR",
        "Add Milesight NVR": "إضافة Milesight NVR",
        "Auto-record video on motion detection, package detection": "تسجيل الفيديو تلقائياً عند اكتشاف الحركة أو الطرد",
        "A 7-day free trial is included with your subscription.": "يشتمل اشتراكك على فترة تجريبية مجانية لمدة 7 أيام.",
        "For service renewal, please reach out to your provider.": "لتجديد الخدمة يرجى التواصل مع مزود الخدمة.",
        "Allow the Property Manager to view recorded videos": "السماح لمسؤول العقار بمشاهدة الفيديوهات المسجلة",
        "Please ensure the WiFi network is working properly.": "يرجى التأكد من أن شبكة WiFi تعمل بشكل صحيح.",
        "Edit akubela Smart Locks": "تعديل أقفال akubela الذكية",
        "Upgraded Successfully!": "تمت الترقية بنجاح!",
        "Upgraded Failed!": "فشلت عملية الترقية!",
        "Editing...": "جارٍ التعديل...",
        "Edited successfully!": "تم التعديل بنجاح!",
        "Edited Failed!": "فشل التعديل!",
        "Downloading video...": "جارٍ تحميل الفيديو...",
        "All Locks": "جميع الأقفال",
        "Select Locks": "اختر الأقفال",
        "The {0} digits PIN can be used once the akubela smart lock is connected to the network. Please note that it may take a short time for the PIN to take effect after synchronization.": "يمكن استخدام رمز PIN المكون من {0} أرقام بمجرد اتصال القفل الذكي akubela بالشبكة. يرجى ملاحظة أن الرمز قد يحتاج لبعض الوقت ليصبح فعالاً بعد المزامنة.",
        "Please at least select a door or a lock.": "يرجى اختيار باب أو قفل واحد على الأقل.",
        "This lock has already been added to your apartment.": "تمت إضافة هذا القفل إلى غرفتك بالفعل.",
        "This lock has already been added to another apartment, please contact your service provider for assistance.": "تمت إضافة هذا القفل إلى غرفة أخرى، يرجى الاتصال بمقدم الخدمة الخاص بك للمساعدة.",
        "LockBody Version": "إصدار جسم القفل",
        "Two-factor Authentication": "المصادقة الثنائية",
        "Monitoring Scope": "نطاق المراقبة",
        "Stay Duration": "مدة البقاء",
        "Volume Settings": "إعدادات مستوى الصوت",
        "get card list for lock error": "خطأ في الحصول على قائمة بطاقات القفل",
        "get card list parse fail": "فشل في تحليل قائمة البطاقات",
        "get pin list for lock error": "خطأ في الحصول على قائمة رموز القفل",
        "get pin list parse fail": "فشل في تحليل قائمة الرموز",
        "fingerprint code must be less than 2048 characters or empty.": "يجب ألا يزيد رمز البصمة عن 2048 حرفاً أو يكون فارغاً.",
        "Personnel not in office.": "الأشخاص ليسوا في المكتب.",
        "customize form fail.": "فشل تخصيص النموذج.",
        "smart lock type error.": "خطأ في نوع القفل الذكي.",
        "invalid client id or secret": "معرّف العميل أو المفتاح غير صالح",
        "invalid account or password": "الحساب أو كلمة المرور غير صالحة",
        "invalid access token": "رمز وصول غير صالح",
        "invalid refresh token": "رمز التحديث غير صالح",
        "no permission to access this project": "لا يوجد تصريح للوصول لهذا المشروع",
        "Stay Alarm Time": "زمن إنذار التوقف",
        "This function only support sl20 lock.": "هذه الميزة تدعم فقط قفل sl20.",
        "Json marshal error.": "خطأ في تحويل Json.",
        "Json unmarshal error.": "خطأ في فك تحويل Json.",
        "Illegal request, not added within valid time.": "طلب غير قانوني، لم تتم الإضافة ضمن الوقت المسموح.",
        "invalid nvr type": "نوع NVR غير صالح",
        "project is empty": "المشروع فارغ",
        "project type is invalid": "نوع المشروع غير صالح",
        "owner is invalid": "المالك غير صالح",
        "url is invalid": "الرابط غير صالح",
        "password is invalid": "كلمة المرور غير صالحة",
        "building is invalid": "المبنى غير صالح",
        "fail to get data": "فشل الحصول على البيانات",
        "invalid allow pm view type": "نوع السماح بمشاهدة مدير العقار غير صالح",
        "Data not exist.": "البيانات غير موجودة.",
        "cannot find community PrivateKey.": "تعذر العثور على مفتاح خاص للمجتمع.",
        "cannot find single PrivateKey.": "تعذر العثور على مفتاح خاص فردي.",
        "The third party not exist.": "الطرف الثالث غير موجود.",
        "{0} and indoor monitors/guard phones": "{0} والشاشات الداخلية/هاتف الحارس",
        "{0} and indoor monitors/guard phones, with phone as backup": "الاتصال أولاً بـ {0} والشاشات الداخلية/هاتف الحارس، وإذا لم يتم الرد الاتصال بالهاتف المحمول",
        "Indoor monitors/guard phones with {0} as backup": "الاتصال أولاً بالشاشات الداخلية/هاتف الحارس، وإذا لم يتم الرد الاتصال بـ {0}",
        "Indoor monitors/guard phones with {0} as backup, finally the phone": "الاتصال بالشاشات الداخلية/هاتف الحارس أولاً، ثم بـ {0}، وأخيراً الهاتف المحمول",
        "{0} Intercom Feature": "ميزة الاتصال الداخلي لـ {0}",
        "Capture on {0}": "لقطة شاشة على تطبيق {0}",
        "{0} Intercom Feature is not activated or has expired.": "ميزة الاتصال الداخلي {0} غير مفعلة أو انتهت صلاحيتها.",
        "fingerprint code must be equal 1620 characters or empty.": "رمز البصمة يجب أن يكون 1620 حرفاً بالضبط أو فارغاً.",
        "To ensure a successful upgrade, please make sure the lock\'s battery level is above 40% before proceeding.": "لضمان نجاح التحديث، يرجى التأكد من أن مستوى بطارية القفل أعلى من 40٪ قبل المتابعة.",
        "Automatic Locking Time": "مدة القفل التلقائي",
        "WiFi Keep-Alive": "الحفاظ على الواي فاي نشطًا",
        "WiFi Setting": "إعداد الواي فاي",
        "Connecting the network...": "جاري الاتصال بالشبكة...",
        "Set successfully!": "تم الإعداد بنجاح!",
        "The offline code can be used even if the lock is not connected to WiFi.": "يمكن استخدام الرمز غير المتصل حتى وإن لم يكن القفل متصلًا بالواي فاي.",
        "Enabling this feature will increase the lock\'s power consumption.": "تفعيل هذه الميزة سيزيد من استهلاك القفل للطاقة.",
        "Each offline code can only be used once.": "كل رمز غير متصل يمكن استخدامه مرة واحدة فقط.",
        "Receiver Info": "معلومات المُستلم",
        "log id": "معرف الدخول",
        "Create HW SN Config Empty SN.": "إنشاء إعداد SN لهواوي. SN فارغ.",
        "The SN": "الرقم التسلسلي",
        "SN can contain up to 32 characters.": "يمكن أن يحتوي الرقم التسلسلي حتى 32 حرفاً.",
        "Check HW SN Not Found.": "تعذر العثور على SN لهواوي.",
        "the end user not found": "المستخدم النهائي غير موجود",
        "Family Call": "مكالمة عائلية",
        "During the upgrade, all lock-related functions will be temporarily unavailable.": "أثناء التحديث جميع وظائف القفل ستتوقف مؤقتًا.",
        "8-digit PIN code starting with \"9\" is invalid!": "رمز الـPIN المكون من 8 أرقام والذي يبدأ بـ\"9\" غير صالح!",
        "Lock name length must be between 1 and 50": "يجب أن يكون طول اسم القفل بين 1 و50",
        "The number of personnel with landline service cannot exceed the number of those with {0} Intercom.": "لا يمكن أن يتجاوز عدد الأشخاص الذين لديهم خدمة الهاتف الأرضي عدد الأشخاص الذين لديهم خدمة الاتصال الداخلي {0}.",
        "The number of admins with landline service cannot exceed the number of those with {0} Intercom.": "لا يمكن أن يتجاوز عدد المسؤولين الذين لديهم خدمة الهاتف الأرضي عدد المسؤولين الذين لديهم خدمة الإنتركم {0}.",
        "charge type": "نوع الرسوم",
        "The number of personnel with landline service cannot exceed the number of those with SmartPlus Intercom.": "عدد الأشخاص الذين لديهم خدمة الهاتف الأرضي لا يمكن أن يتجاوز عدد الذين لديهم خدمة SmartPlus Intercom.",
        "The number of admins with landline service cannot exceed the number of those with SmartPlus Intercom.": "عدد المشرفين الذين لديهم خدمة الهاتف الأرضي لا يمكن أن يتجاوز عدد المشرفين الذين لديهم خدمة SmartPlus Intercom.",
        "A reader cannot be configured to use both Wiegand and RS485 simultaneously.": "لا يمكن إعداد القارئ لاستخدام كل من ويغاند و RS485 في نفس الوقت.",
        "parameter error": "خطأ في المعلمة",
        "community name already exist": "اسم المجتمع موجود بالفعل",
        "personnel app without intercom feature number": "تطبيق الموظفين بدون رقم ميزة الاتصال الداخلي",
        "check feature billing charge plan new error": "خطأ التحقق من خطة فوترة الميزات الجديدة",
        "subscription not found": "الاشتراك غير موجود",
        "System setting record not found.": "لم يتم العثور على سجل إعداد النظام.",
        "Smart home not enabled.": "لم يتم تفعيل المنزل الذكي.",
        "the apt call type value is invalid.": "قيمة نوع الاتصال بالشقة غير صالحة.",
        "the ip call or sip call value is invalid.": "قيمة مكالمة IP أو مكالمة SIP غير صالحة.",
        "pinCode must be 2-8 digit number, but cannot be an 8-digit number starting with 9 or empty.": "يجب أن يكون رمز التعريف بين 2 إلى 8 أرقام، ولا يمكن أن يكون رقمًا مكونًا من 8 أرقام يبدأ بالرقم 9 أو فارغًا.",
        "rfCard must be A-F0-9 and less than 16 bits or empty.": "يجب أن تكون بطاقة rf من A-F0-9 وأقل من 16 خانة أو فارغة.",
        "owner cannot be empty.": "لا يمكن أن يكون المالك فارغًا.",
        "creator cannot be empty.": "لا يمكن أن يكون المنشئ فارغًا.",
        "the creator type value is invalid": "قيمة نوع المنشئ غير صالحة",
        "the IsCreateByPm value is invalid": "قيمة IsCreateByPm غير صالحة",
        "the pinCode already exist": "رمز التعريف موجود بالفعل",
        "the rfCard already exist": "بطاقة rf موجودة بالفعل",
        "license plate is invalid.": "لوحة السيارة غير صالحة.",
        "owner info is invalid.": "معلومات المالك غير صالحة.",
        "uhf is invalid.": "UHF غير صالح.",
        "time control is invalid.": "التحكم في الوقت غير صالح.",
        "You have reached the limit of 5 Vehicle License Plate and are not allowed to add": "لقد وصلت إلى الحد الأقصى لخمسة لوحات سيارات ولا يُسمح لك بالإضافة",
        "the plate already exist": "اللوحة موجودة بالفعل",
        "the uhf already exist": "UHF موجود بالفعل",
        "empty community": "مجتمع فارغ",
        "no find license Plate": "لم يتم العثور على لوحة سيارة",
        "IDAccess mode must be 0, 1, or 2.": "يجب أن يكون وضع الوصول بالمعرف 0 أو 1 أو 2.",
        "Run field is required when mode is 1 or 2.": "حقل التشغيل مطلوب عندما يكون الوضع 1 أو 2.",
        "Serial field is required when mode is 2.": "حقل الرقم التسلسلي مطلوب عندما يكون الوضع 2.",
        "the pin cannot be empty": "لا يمكن أن يكون رمز التعريف فارغًا",
        "the rfCard cannot be empty": "لا يمكن أن تكون بطاقة rf فارغة",
        "the IDAccess already exist": "وصول المعرف موجود بالفعل",
        "the resident cannot be empty": "لا يمكن أن يكون الساكن فارغًا",
        "the fingerprint cannot be empty": "البصمة لا يمكن أن تكون فارغة",
        "the face cannot be empty": "الوجه لا يمكن أن يكون فارغًا",
        "not found pin": "لم يتم العثور على رمز التعريف",
        "not found rfCard": "لم يتم العثور على بطاقة rf",
        "not found IDAccess": "لم يتم العثور على وصول المعرف",
        "not found fingerprint": "لم يتم العثور على البصمة",
        "not found face": "لم يتم العثور على الوجه",
        "face pic is invalid.": "صورة الوجه غير صالحة.",
        "community build and room cannot be empty.": "المجتمع والمبنى والغرفة لا يمكن أن تكون فارغة.",
        "device info mac cannot be empty.": "معلومات جهاز MAC لا يمكن أن تكون فارغة.",
        "scheduler type must be 0,1,2 or time format is invalid or dataflag not in 0-127.": "يجب أن يكون نوع الجدولة 0 أو 1 أو 2 أو تنسيق الوقت غير صحيح أو علامة البيانات ليست بين 0-127.",
        "MAC address cannot be empty.": "عنوان MAC لا يمكن أن يكون فارغًا.",
        "MAC address 0C1105000000 is not allowed.": "عنوان MAC 0C1105000000 غير مسموح به.",
        "MAC address must be 12 hexadecimal characters.": "يجب أن يكون عنوان MAC مكونًا من 12 رمزًا ست عشريًا.",
        "Scheduler type value is invalid.": "قيمة نوع الجدولة غير صالحة.",
        "parse is fail": "فشل التحليل",
        "the fingerprint already exist": "البصمة موجودة بالفعل",
        "the licensePlate cannot be empty": "لا يمكن أن تكون لوحة السيارة فارغة",
        "the licensePlate already exist": "لوحة السيارة موجودة بالفعل",
        "idaccess run must be 10 digit number or end with -K.": "تشغيل وصول المعرف يجب أن يكون رقمًا مكونًا من 10 أرقام أو ينتهي بـ -K.",
        "idaccess serial must be 9 digit number.": "يجب أن يكون الرقم التسلسلي لوصول المعرف مكونًا من 9 أرقام.",
        "relay not in 0-15": "المُرحّل ليس بين 0-15",
        "security relay not in 0-3": "مُرحّل الأمان ليس بين 0-3",
        "file name is wrong": "اسم الملف خاطئ",
        "access mode specified": "وضع الوصول المحدد",
        "create community user accessmode failed.": "فشل إنشاء وضع وصول مستخدم المجتمع.",
        "delete community user accessmode failed.": "فشل حذف وضع وصول مستخدم المجتمع.",
        "Cannot delete building because it has associated users.": "لا يمكن حذف المبنى لأنه مرتبط بمستخدمين.",
        "Cannot delete building because it has associated Salto devices.": "لا يمكن حذف المبنى لأنه مرتبط بأجهزة سالتو.",
        "community building not found": "مبنى المجتمع غير موجود",
        "Invalid Name Display": "عرض الاسم غير صالح",
        "The Community does not exist.": "المجتمع غير موجود.",
        "Update CommunityIsInstallerKit Error.": "خطأ في تحديث CommunityIsInstallerKit.",
        "Dis Not SupportCommunityCalls Error.": "الوكيل لا يدعم مكالمات المجتمع - خطأ.",
        "Community Has Special Device, Not Allowed To Delete.": "لدى المجتمع جهاز خاص، غير مسموح بالحذف.",
        "The project smart home switch must be disabled": "يجب تعطيل مفتاح المنزل الذكي للمشروع",
        "There are ITec Locks in project": "هناك أقفال ITec في المشروع",
        "There are Salto Locks in project": "هناك أقفال Salto في المشروع",
        "There are Dormakaba Locks in project": "هناك أقفال Dormakaba في المشروع",
        "It is rent manager project": "هو مشروع مدير الإيجار",
        "It is installer account": "هو حساب المثبّت",
        "contact preference type": "نوع تفضيل الاتصال",
        "Floor list is required when not all floors.": "قائمة الطوابق مطلوبة عندما لا تكون جميع الطوابق.",
        "Building floors list is required when all buildings.": "قائمة طوابق المبنى مطلوبة عندما تكون جميع المباني.",
        "Indoor monitor name is required.": "اسم جهاز المراقبة الداخلي مطلوب.",
        "The primary account is not activated.": "الحساب الرئيسي غير مفعل.",
        "You can\'t create more family member accounts.": "لا يمكنك إنشاء المزيد من حسابات أفراد العائلة.",
        "community user not found": "مستخدم المجتمع غير موجود",
        "community is empty": "المجتمع فارغ",
        "the end user not master user": "المستخدم النهائي ليس مستخدمًا رئيسيًا",
        "the end user not member user": "المستخدم النهائي ليس عضوًا",
        "The email already exists and cannot be repeated": "البريد الإلكتروني موجود بالفعل ولا يمكن تكراره",
        "The mobile Number already exists": "رقم الجوال موجود بالفعل",
        "The room number format error.": "خطأ في تنسيق رقم الغرفة.",
        "community not found": "المجتمع غير موجود",
        "resident not found": "الساكن غير موجود",
        "installer not found": "المثبت غير موجود",
        "Operation Failed!": "فشل العملية!",
        "You don\'t have operate permission": "ليس لديك إذن التشغيل",
        "You cannot select Relay and Door at the same time": "لا يمكنك اختيار المرحل والباب في الوقت نفسه",
        "user don\'t active": "المستخدم غير مفعل",
        "User has expired": "انتهت صلاحية المستخدم",
        "timestamp must be within 3 minutes of current server time": "يجب أن يكون الطابع الزمني ضمن 3 دقائق من وقت الخادم الحالي",
        "cannot find single rf Card.": "لا يمكن العثور على بطاقة rf واحدة.",
        "cannot find community rf Card.": "لا يمكن العثور على بطاقة rf الخاصة بالمجتمع.",
        "smartLock model": "طراز القفل الذكي",
        "the project does not open smart home": "المشروع لا يفتح المنزل الذكي",
        "php web server error": "خطأ في خادم ويب php",
        "Ins not found.": "لم يتم العثور على Ins.",
        "RentManage Unit Not Set.": "وحدة إدارة الإيجار غير محددة.",
        "add audit log error": "خطأ في إضافة سجل التدقيق",
        "check building in error": "خطأ في فحص المبنى",
        "Special devices cannot be deleted": "لا يمكن حذف الأجهزة الخاصة",
        "the email is empty": "البريد الإلكتروني فارغ",
        "the email format is incorrect": "تنسيق البريد الإلكتروني غير صحيح",
        "the mobile number is empty": "رقم الجوال فارغ",
        "the mobile number format is incorrect": "تنسيق رقم الجوال غير صحيح",
        "Site not found": "الموقع غير موجود",
        "User not found": "المستخدم غير موجود",
        "invalid time format": "تنسيق الوقت غير صالح",
        "ground floor type": "نوع الطابق الأرضي",
        "Start floor range error, valid values are -10 to -1, G0, G1, G2, 1 to 128.": "خطأ في نطاق بدء الطابق، القيم الصحيحة هي -10 إلى -1، G0، G1، G2، 1 إلى 128.",
        "Building ID must be between 1 and 99.": "يجب أن يكون معرف المبنى بين 1 و99.",
        "Community building name": "اسم مبنى المجتمع",
        "Building ID already exists in this community.": "معرف المبنى موجود بالفعل في هذا المجتمع.",
        "building ID": "معرف المبنى",
        "Community building not found.": "لم يتم العثور على مبنى المجتمع.",
        "Cannot delete building because it has associated devices.": "لا يمكن حذف المبنى لأنه مرتبط بأجهزة.",
        "project is not valid": "المشروع غير صالح",
        "Cannot delete building because it has associated salto devices.": "لا يمكن حذف المبنى لأنه مرتبط بأجهزة سالتو.",
        "Cannot delete building because it has associated iTec devices.": "لا يمكن حذف المبنى لأنه مرتبط بأجهزة iTec.",
        "Cannot delete building because it has associated dormakaba devices.": "لا يمكن حذف المبنى لأنه مرتبط بأجهزة dormakaba.",
        "member limit num": "حد عدد الأعضاء",
        "Indoor Monitor No Set Error.": "خطأ: لم يتم تعيين جهاز المراقبة الداخلي.",
        "The room not has indoor": "الغرفة ليس بها جهاز داخلي",
        "check user in building error": "تحقق من وجود المستخدم في المبنى الخطأ",
        "The name specified is already in use.": "الاسم المحدد مستخدم بالفعل.",
        "This timeblock overlaps with an existing one. Please adjust it.": "هذه الفترة الزمنية تتداخل مع فترة زمنية موجودة بالفعل. يرجى تعديلها.",
        "This door status changed. Please try again.": "تم تغيير حالة هذا الباب. يرجى المحاولة مرة أخرى.",
        "the lock can\'t bind this community": "لا يمكن للقفل ربط هذه المجتمع",
        "The custom quantity limit has been exceeded!": "تم تجاوز الحد المسموح للكمية المخصصة!",
        "This time span overlaps with an existing one. Please adjust it.": "هذه الفترة الزمنية تتداخل مع فترة زمنية موجودة. يرجى تعديلها.",
        "This one time runs overlap with an existing one time runs effective time. Please adjust it.": "يتداخل وقت التشغيل لمرة واحدة هذا مع وقت التشغيل الفعّال لمرة واحدة موجود. يرجى التعديل.",
        "Operation Failed. Please try again.": "فشلت العملية. يرجى المحاولة مرة أخرى.",
        "The image is not a front view.": "الصورة ليست عرضًا أماميًا.",
        "A mask was detected.": "تم اكتشاف قناع.",
        "The image resolution is too low.": "دقة الصورة منخفضة جدًا.",
        "No face was detected.": "لم يتم اكتشاف أي وجه.",
        "The file size is too large.": "حجم الملف كبير جدًا.",
        "The face in the image is too large.": "الوجه في الصورة كبير جدًا.",
        "The face in the image is too small.": "الوجه في الصورة صغير جدًا.",
        "Multiple faces detected.": "تم اكتشاف عدة وجوه.",
        "The face is not clear enough.": "الوجه غير واضح بما فيه الكفاية.",
        "Face detection failed.": "فشل اكتشاف الوجه.",
        "Please enter a value between 1 and 9999": "يرجى إدخال قيمة بين 1 و 9999",
        "Please select which input your door sensor is connected to.": "يرجى اختيار مدخل المستشعر الذي تم توصيل حساس الباب به.",
        "Add temp key failed, please try it again": "فشل إضافة المفتاح المؤقت، يرجى المحاولة مرة أخرى",
        "Dis Not Support Dynamic QRCode Error.": "خطأ عدم دعم رمز الاستجابة السريعة الديناميكي.",
        "QR code not exist": "رمز الاستجابة السريعة غير موجود",
        "The temp key has expired.": "انتهت صلاحية المفتاح المؤقت.",
        "The device is not in the office": "الجهاز غير موجود في المكتب",
        "The device is already assigned.": "تم بالفعل تخصيص الجهاز.",
        "The device cannot be assigned to any user.": "لا يمكن تخصيص الجهاز لأي مستخدم.",
        "You cannot select an option with fewer users than the current project members.": "لا يمكنك اختيار خيار يحتوي على عدد مستخدمين أقل من عدد أعضاء المشروع الحاليين.",
        "File check failed. Please download the latest template and try again.": "فشل التحقق من الملف. يرجى تنزيل النموذج الأحدث والمحاولة مرة أخرى.",
        "Dynamic QR Code not active.": "رمز الاستجابة السريعة الديناميكي غير نشط.",
        "Dynamic QR Code not enable.": "لم يتم تفعيل رمز الاستجابة السريعة الديناميكي.",
        "{0} not found.": "لم يتم العثور على {0}.",
        "Tier charge plan": "خطة رسوم الطبقات",
        "Feature billing charge plan new": "خطة رسوم الفوترة للميزة الجديدة",
        "Feature billing gradient charge plan": "خطة رسوم التدرج لفوترة الميزة",
        "The exit time cannot be earlier than the entry time.": "لا يمكن أن يكون وقت الخروج أبكر من وقت الدخول.",
        "User Name or Password": "اسم المستخدم أو كلمة المرور",
        "You can only link up to 5 sites.": "يمكنك ربط ما يصل إلى 5 مواقع فقط.",
        "This license plate is already registered to a resident and cannot be added to the blocklist.": "لوحة المركبة هذه مسجلة بالفعل لأحد السكان ولا يمكن إضافتها إلى قائمة الحظر.",
        "This license plate is blocklisted and cannot be registered as a vehicle.": "هذه اللوحة محظورة ولا يمكن تسجيلها كمركبة.",
        "Elevator not configured in company access floor.": "لم يتم تهيئة المصعد في طابق الوصول الخاص بالشركة.",
        "the device is not in the office": "الجهاز غير موجود في المكتب",
        "A maximum of 1000 data items can be imported": "يمكن استيراد 1000 عنصر بيانات كحد أقصى",
        "Exit time cannot be later than the current time.": "لا يمكن أن يكون وقت الخروج متأخرا عن الوقت الحالي.",
        "You can only import a file at a time in the current parking lot.": "يمكنك استيراد ملف واحد فقط في كل مرة في موقف السيارات الحالي.",
        "The license plate is already in the blocklist.": "رقم اللوحة موجود بالفعل في قائمة الحظر.",
        "Building name too long.": "اسم المبنى طويل جدًا.",
        "Unlock failed. Permission denied by user.": "فشل فتح القفل. رفض المستخدم الإذن.",
        "Please remove the sensor device(s) before disabling this feature.": "يرجى إزالة جهاز/أجهزة المستشعر قبل تعطيل هذه الميزة.",
        "Operation failed! Daily limit of 15 records exceeded for this user.": "فشلت العملية! لقد تجاوز هذا المستخدم الحد اليومي البالغ 15 سجلًا.",
        "A maximum of {0} public devices can be created within a single project. If you need to add more public devices, please contact Akuvox Technical Support at support@akuvox.com.": "يمكن إضافة ما يصل إلى {0} أجهزة عامة لكل مشروع. لإضافة المزيد، يرجى الاتصال بالدعم الفني لـ Akuvox على support{'@'}akuvox.com.",
        "A maximum of {0} apartment devices can be created within a single project. If you need to add more apartment devices, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} apartment devices can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} buildings can be created within a single project. If you need to add more buildings, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} buildings can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} apartments can be created within a single project. If you need to add more apartments, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} apartments can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} residents can be created within a single project. If you need to add more residents, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} residents can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} delivery personnel can be created within a single project. If you need to add more delivery personnel, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} delivery personnel can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} access groups can be created within a single project. If you need to add more access groups, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} access groups can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} office groups can be created within a single project. If you need to add more office groups, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} office groups can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} admins can be created within a single project. If you need to add more admins, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} admins can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} companies can be created within a single project. If you need to add more companies, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} companies can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} personnel accounts can be created within a single project. If you need to add more personnel accounts, please contact Akuvox Technical Support at support@akuvox.com.": "يمكن إضافة ما يصل إلى {0} حسابات موظفين لكل مشروع. لإضافة المزيد، يرجى الاتصال بالدعم الفني لـ Akuvox على support{'@'}akuvox.com.",
        "cancel": "الغاء",


    }
};
